<template>
    <va-edit-layout>
        <RentalTransactionEventCharge-form
            :id="id"
            :title="title"
            :item="item"
        ></RentalTransactionEventCharge-form>
    </va-edit-layout>
</template>

<script>
export default {
    props: ["id", "title", "item"],
};
</script>
